import React, { useState, useRef } from 'react';
import axios from 'axios';
import Navigation from '../navigation/navigationVisiteur';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Alert } from 'react-bootstrap';

function InformationEquipe(props) {
  const [error, setError] = useState(null);
  const [success, setSucces] = useState(null);
  const [changement, setChangement] = useState(false);
  const [adresse, setAdresse] = useState('');
  const [logo, setLogo] = useState('');
  const [categorie, setCategorie] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const logoRef = useRef('');


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setChangement(false);
    setError(null);
    setSucces(false);

    if (adresse === props.userData.user.donnée.results[0].adresse) {
      setError("Les deux adresses sont identiques");
      setIsLoading(false);
      return;
    } else if (categorie === props.userData.user.donnée.results[0].categorie) {
      setError("Les catégories sont identiques");
      setIsLoading(false);
      return;
    }

    try {
      var formData = new FormData();
      formData.append('id_equipe', props.userData.user.donnée.results[0].id_equipe);
      formData.append("adresse", adresse);
      formData.append("categorie", categorie);
      formData.append('logo', logo);

      await axios.patch(`${apiUrl}/parametre/modification/equipe`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true
      });

      setError(null);
      setLogo('');
      setAdresse('');
      setCategorie('');
      setIsLoading(false);
      setSucces(true)
      setTimeout(() => {
        window.location.reload();
      }, 5000);

      logoRef.current.value = null;


      setTimeout(() => {
        setSucces(false);
      }, 20000);

    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        setError(error.response.data.message);
      } else {
        setError(true);
      }
    }
  };


  return (
    <>
      {isLoading && (
        <>
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br />
            <span className="loader"></span>
          </div>
        </>
      )}
      {changement && (
        <Modal show={changement} onHide={() => setChangement(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Modification de données du club </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>Êtes-vous sûr de modifier les informations du club  ?</>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setChangement(false)}>
              Annuler
            </Button>
            <Button variant="primary" onClick={(e) => { handleSubmit(e) }} style={{ backgroundColor: "#00E676", borderColor: '#00E676' }}>
              Modifier les informations
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {props.userData ? (
        <>
          {success && (
            <Alert key="success" variant="success" style={{ fontSize: "15px", margin: "auto", width: "80%" }}>
              Félicitations ! Les informations de l'équipe ont été modifées avec succès.
            </Alert>
          )}
          {error && (
            <Alert key="danger" variant="danger" style={{ fontSize: "15px", margin: "auto", width: "95%" }}>
              Erreur ! {error}.
            </Alert>
          )}
          <h2 style={{ textAlign: "center" }}>Informations du club</h2>
          <div className="card-body">
            <div className="ajout2">
              <form className="Invite_Joueur" onSubmit={(e) => { e.preventDefault(); setChangement(true); }} >
                <div>
                  <label htmlFor="equipe" className="label-1" >
                    <br />Nom de l'equipe<br />
                    <input
                      name="equipe"
                      type="text"
                      id="equipe"
                      value={" " + props.userData.user.donnée.results[0].nom_equipe}
                      readOnly
                    />
                  </label>
                </div>
                <div>
                  <br />Logo du club<br />
                  <img src={`${apiUrl}/image/equipe/${props.userData.user.donnée.results[0].logo}`} alt="logo de l'équipe" style={{ borderRadius: "10px" }} width="100" height="100" />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <label htmlFor="new_logo" className="label-1" >
                    <Form.Group className="mb-3">
                      <Form.Label>Nouveau logo en PNG</Form.Label>
                      <Form.Control type="file" style={{ width: "100%", height: "100%" }} id="file" name="file" accept=".png" ref={logoRef} onChange={(e) => setLogo(e.target.files[0])} />
                    </Form.Group>
                  </label>
                </div>
                <div>
                  <label htmlFor="categorie" className="label-1" >
                    <br />Catégorie d'âge<br />
                    <input
                      name="categorie"
                      type="text"
                      id="categorie"
                      readOnly
                      value={" " + props.userData.user.donnée.results[0].categorie}
                    />
                  </label>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <label htmlFor="new_categorie" className="label-1" >
                      <br />Changer de catégorie<br />
                      <Form.Select  
                                required                            
                              name="catégorie"
                              value={categorie} onChange={(e) => setCategorie(e.target.value)}>
                              <option>Sélectionner</option>
                              <option value="U5">U5</option>
                              <option value="U6">U6</option>
                              <option value="U7">U7</option>
                              <option value="U8">U8</option>
                              <option value="U9">U9</option>
                              <option value="U10">U10</option>
                              <option value="U11">U11</option>
                              <option value="U12">U12</option>
                              <option value="U13">U13</option>
                              <option value="U14">U14</option>
                              <option value="U15">U15</option>
                              <option value="U16">U16</option>
                              <option value="U17">U17</option>
                              <option value="U18">U18</option>
                              <option value="U19">U19</option>
                              <option value="U20">U20</option>
                              <option value="U21">U21</option>
                              <option value="Réserve">Réserve</option>
                              <option value="Equipe première">Equipe première</option>
                  </Form.Select>
                  </label>
                </div>
                <div>
                  <label htmlFor="adress" className="label-1" >
                    <br />Adresse du club<br />
                    <input
                      name="adress"
                      type="text"
                      id="text"
                      readOnly
                      value={" " + props.userData.user.donnée.results[0].adresse}
                    />
                  </label>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <label htmlFor="new_adress" className="label-1" >
                    <br />Nouvelle adresse<br />
                    <input
                      name="new_adress"
                      type="text"
                      id="new_adress"
                      placeholder="Rue albert 6, 5000 Namur"
                      value={adresse} onChange={(e) => setAdresse(e.target.value)}
                    />
                  </label>
                </div>
                <div>
                  <br />
                  <button type="submit" className="conect" style={{ margin: "auto" }}>
                    Modifier les informations de l'équipe
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      ) : (
        <>
          <Navigation />
          <div id="alert-message" className="alert" >
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
          </div>
        </>
      )}
    </>
  );
}

export default InformationEquipe;
